module.exports = __webpack_public_path__ + "img/submit-select.e95788d4.png";